module.exports = __webpack_public_path__ + "static/media/scikitlearn.a4ae2966.png";